module.exports = __webpack_public_path__ + "img/skin-oiliness.17f14708.svg";